import React from 'react';
import { useExportNotifications } from '@/hooks/useExportNotifications';

interface ExportNotificationsProviderProps {
  children: React.ReactNode;
  connectionId?: string;
  enabled?: boolean;
}

export const ExportNotificationsProvider: React.FC<ExportNotificationsProviderProps> = ({
  children,
  connectionId,
  enabled = true
}) => {
  // Initialize global export notifications
  useExportNotifications({ connectionId, enabled });

  return <>{children}</>;
};

export default ExportNotificationsProvider;